import { DatePicker, CustomProvider } from "rsuite";
import arEG from "../i18n/rsuiteArabic";
import { useTranslation } from "react-i18next";
import "./AvailableDatePicker.css";

// Day/month name/year: "31/May/2026" / "31/مايو/2026" (Western digits).
export const dateFormat = (language) =>
  language === "ar" ? "d/MMMM/yyyy" : "d/MMM/yyyy";

const AvailableDatePicker = ({
  availableDates,
  value,
  onChange,
  onClean,
  cleanable = false,
  style,
  className,
  defaultValue,
  placement = "autoVerticalStart",
  size = "md",
  appearance = "default",
}) => {
  const { t, i18n } = useTranslation();
  const shouldDisableDate = (date) => {
    if (availableDates == null) return false;
    if (availableDates.length === 0) return true;
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return !availableDates.some((availableDate) => {
      const ad = new Date(availableDate);
      ad.setHours(0, 0, 0, 0);
      return ad.getTime() === d.getTime();
    });
  };

  const renderCell = (date) => {
    if (availableDates == null) {
      return <div className="adp-day">{date.getDate()}</div>;
    }
    const isAvailable = availableDates.some((availableDate) => {
      const ad = new Date(availableDate);
      ad.setHours(0, 0, 0, 0);
      const d = new Date(date);
      d.setHours(0, 0, 0, 0);
      return ad.getTime() === d.getTime();
    });
    return (
      <div className={`adp-day${isAvailable ? " adp-day--available" : ""}`}>
        {date.getDate()}
      </div>
    );
  };

  return (
    <CustomProvider
      locale={i18n.resolvedLanguage === "ar" ? arEG : undefined}
      rtl={i18n.dir() === "rtl"}
    >
      <DatePicker
        size={size}
        placement={placement}
        cleanable={cleanable}
        appearance={appearance}
        format={dateFormat(i18n.resolvedLanguage)}
        // Picked from the calendar only: typing would show rsuite's raw
        // format ("d/MMMM/yyyy") in place of the hint.
        editable={false}
        placeholder={t("dates.placeholder")}
        value={value}
        defaultValue={defaultValue}
        shouldDisableDate={shouldDisableDate}
        renderCell={renderCell}
        menuClassName="available-date-picker"
        style={style}
        className={className}
        onChange={onChange}
        onClean={onClean}
      />
    </CustomProvider>
  );
};

export default AvailableDatePicker;
